import { render } from "./ProjectDataManager.vue?vue&type=template&id=34bc5450&scoped=true"
import script from "./ProjectDataManager.vue?vue&type=script&lang=js"
export * from "./ProjectDataManager.vue?vue&type=script&lang=js"

import "./ProjectDataManager.vue?vue&type=style&index=0&id=34bc5450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bc5450"]])

export default __exports__